module.exports = __webpack_public_path__ + "static/media/gov-logo.e6432eb4.svg";